import { gql } from "@edreamsodigeo/frontend-api-client";

export const GET_REACTIVATION_MY_TRIPS_USER_ACCOUNT = gql`
  query GetMyTripsReactivationUserAccount(
    $userAccountRequest: UserAccountRequest
  ) {
    userAccount(userAccountRequest: $userAccountRequest) {
      isLoggedIn
      email
      userMembership {
        isActive
        subscriptionDetails {
          cancellationInfo {
            cancellationDate
            isCancellationAvailable
          }
          expirationDate
          isAutoRenewalEnabled
          isFreeTrial
        }
      }
    }
  }
`;
